import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName {
	label: string;
	tooltip?: string;
}

export const VaultPerformanceStatLabel = ({
	label,
	tooltip,
	className,
}: Props) => {
	return (
		<Tooltip className={className} content={tooltip} disabled={!tooltip}>
			{label}
		</Tooltip>
	);
};
